// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".4d3874af6510a47ffe016f0f3248d68bb696b54b.chunk.bundle.js";
};